import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { login, loginWithPhone, loginWithEmail, secondConfirmLogin, logout, getUserInfo, checkActivated, getMessage, getContentByMsgId, hasRead, removeReaded, restoreTrash, getUnreadCount } from "@/service/user";
import { getUnitState, saveMfaSettings, getPersonalState } from "@/service/version";
import { getAppList } from "@/service/appList";
import { encrypt } from "@/libs/rsa";
import { setToken, getToken, setLogin, getLogin, clearCookieAllVariants, saveLocalUser, getMFAConfigs, getPersonConfig } from "@/libs/auth";
import { menuListJs } from "@/libs/menu-list";
import _ from "lodash";
import Cookies from "js-cookie";
import { findRouterForPath } from "@/libs/watermark";
export default {
  state: {
    userInfo: {},
    gig: false,
    menuList: [],
    visibleApps: [],
    isLogin: getLogin(),
    token: getToken(),
    access: "",
    hasGetInfo: false,
    secondCheck: {},
    unreadCount: 0,
    messageUnreadList: [],
    messageReadedList: [],
    messageTrashList: [],
    messageContentStore: {},
    // MFA配置
    mfaSettings: getMFAConfigs(),
    personalConfig: getPersonConfig()
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = {
        unitName: "",
        userName: "",
        ...state.userInfo,
        ...userInfo
      };
      //保存用户信息
      saveLocalUser(state.userInfo);
    },
    setGig(state, gig) {
      state.gig = gig;
    },
    setMenuList(state, menuList) {
      state.menuList = menuList;
    },
    setVisibleApps(state, visibleApps) {
      state.visibleApps = visibleApps;
    },
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    setSecondCheck(state, status) {
      state.secondCheck = status;
    },
    setLogin(state, status) {
      state.isLogin = status;
      setLogin(status);
    },
    setLogout(state) {
      // 清除所有变体而不是写入 0/false，
      // 避免与后端写入的域变体共存后登录态读取随顺序变化。
      clearCookieAllVariants("unitNumber");
      Cookies.remove("unitId");
      let noClearList = ["language", "userInfo", "wx_auth_code"];
      Object.keys(localStorage).forEach(key => {
        if (noClearList.every(item => item !== key)) {
          localStorage.removeItem(key);
        }
      });

      // userInfo里面保留部分必要字段, 并重新保存在localstore跟store里面
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let userInfoNew = {
        ...userInfo,
        unitId: ""
      };
      saveLocalUser(userInfoNew);
      state.userInfo = userInfoNew;
      state.visibleApps = [];
      state.menuList = menuListJs(userInfoNew, []);
      state.isLogin = false;
      setLogin(false);
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    setMessageCount(state, count) {
      state.unreadCount = count;
    },
    setUnitList(state, list) {
      state.unitList = list;
    },
    setMessageUnreadList(state, list) {
      state.messageUnreadList = list;
    },
    setMessageReadedList(state, list) {
      state.messageReadedList = list;
    },
    setMessageTrashList(state, list) {
      state.messageTrashList = list;
    },
    setMFAConfigs(state, configs) {
      state.mfaSettings = configs;
      localStorage.setItem("mfaSettings", JSON.stringify(configs));
    },
    setPersonConfig(state, config) {
      state.personalConfig = config;
      localStorage.setItem("personalConfig", JSON.stringify(config));
    },
    updateMessageContentStore(state, {
      msg_id,
      content
    }) {
      state.messageContentStore[msg_id] = content;
    },
    moveMsg(state, {
      from,
      to,
      msg_id
    }) {
      const index = state[from].findIndex(_ => _.msg_id === msg_id);
      const msgItem = state[from].splice(index, 1)[0];
      msgItem.loading = false;
      state[to].unshift(msgItem);
    }
  },
  getters: {
    messageUnreadCount: state => state.messageUnreadList.length,
    messageReadedCount: state => state.messageReadedList.length,
    messageTrashCount: state => state.messageTrashList.length
  },
  actions: {
    secondLogin({
      commit
    }, {
      userKey,
      verificationCode,
      accountType,
      mobileAreaCode
    }) {
      return new Promise((resolve, reject) => {
        secondConfirmLogin({
          userKey,
          verificationCode,
          accountType,
          mobileAreaCode
        }).then(res => {
          if (res && res.data && res.data.result === 0) {
            commit("setLogin", true);
          }
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 登录
    handleLogin({
      commit
    }, {
      mobile,
      password,
      accountType,
      mobileAreaCode,
      isLink
    }) {
      mobile = mobile.trim();
      return new Promise((resolve, reject) => {
        login({
          mobile,
          password: encrypt(password),
          accountType,
          mobileAreaCode,
          isLink
        }).then(res => {
          if (res && res.data && res.data.result === 0) {
            console.log(res, commit);
            if (_.has(res.data.retVal, "mobile")) {
              const mobileList = res.data.retVal.mobile.split("-");
              commit("setSecondCheck", {
                mobile: mobile,
                email: mobile,
                mobileMi: mobileList[1],
                emailMi: res.data.retVal.email,
                verificationCode: "",
                mobileAreaCode: mobileAreaCode,
                accountType: accountType,
                show: true
              });
            } else {
              commit("setLogin", true);
            }
          }
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 手机验证码登录
    handlePhoneSubmit({
      commit
    }, body) {
      return new Promise((resolve, reject) => {
        loginWithPhone(body).then(res => {
          if (res && res.data && res.data.result === 0) {
            commit("setLogin", true);
          }
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    //邮箱验证码登录
    handleEmailSubmit({
      commit
    }, body) {
      return new Promise((resolve, reject) => {
        loginWithEmail(body).then(res => {
          if (res && res.data && res.data.result === 0) {
            commit("setLogin", true);
          }
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 主动退出登录
    // eslint-disable-next-line no-unused-vars
    handleLogOut({
      state,
      commit
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(res => {
          if (res && res.data && res.data.result === 0) {
            commit("setLogout");
            // 标记主动登出：登录页据此不自动发起企微静默登录，
            // 避免"登出 → 刷新 → 静默重登 → 再误判未登录"的死循环；
            // 用户点击头像登录时清除该标记。
            sessionStorage.setItem("loggedOut", "1");
            findRouterForPath();
            resolve(res.data);
          }
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 因操作时间过久，需要重新登录时调用
    handleLogOutNoAccord({
      commit
    }) {
      return new Promise(resolve => {
        commit("setLogout");
        findRouterForPath();
        resolve();
      });
    },
    // 获取用户相关信息
    getUserInfo({
      dispatch,
      commit
    }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo().then(async res => {
            const data = res.data;
            const {
              retVal
            } = data;
            // 业务失败时保留现有用户状态，由调用方根据 result 决定是否继续跳转。
            if (data.result === 0) {
              commit("setUserInfo", retVal);
              await dispatch("getVisibleAppsForMenu", retVal);
              // 添加水印
              findRouterForPath();
            }
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取选择GIG实例
    getGig({
      commit
    }) {
      return new Promise((resolve, reject) => {
        try {
          checkActivated().then(res => {
            const data = res.data;
            const {
              retVal
            } = data;
            commit("setGig", retVal);
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取当前菜单
    // 同步管理菜单依赖工作台可见应用，管理员进入单位后先刷新应用列表再生成菜单。
    async getVisibleAppsForMenu({
      commit,
      dispatch
    }, userInfo) {
      let visibleApps = [];
      if (userInfo !== null && userInfo !== void 0 && userInfo.unitId && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isAdmin) === "T") {
        try {
          const {
            data: {
              result,
              retVal
            }
          } = await getAppList();
          visibleApps = result === 0 ? (retVal === null || retVal === void 0 ? void 0 : retVal.apps) || [] : [];
        } catch (error) {
          visibleApps = [];
        }
      }
      commit("setVisibleApps", visibleApps);
      dispatch("getMenuList", userInfo);
      return visibleApps;
    },
    getMenuList({
      state,
      commit
    }, userInfo) {
      commit("setMenuList", menuListJs(userInfo, state.visibleApps));
    },
    // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
    getUnreadMessageCount({
      commit
    }) {
      getUnreadCount().then(res => {
        const {
          data
        } = res;
        commit("setMessageCount", data);
      });
    },
    // 获取消息列表，其中包含未读、已读、回收站三个列表
    getMessageList({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMessage().then(res => {
          const {
            unread,
            readed,
            trash
          } = res.data;
          commit("setMessageUnreadList", unread.sort((a, b) => new Date(b.create_time) - new Date(a.create_time)));
          commit("setMessageReadedList", readed.map(_ => {
            _.loading = false;
            return _;
          }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)));
          commit("setMessageTrashList", trash.map(_ => {
            _.loading = false;
            return _;
          }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)));
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据当前点击的消息的id获取内容
    getContentByMsgId({
      state,
      commit
    }, {
      msg_id
    }) {
      return new Promise(resolve => {
        let contentItem = state.messageContentStore[msg_id];
        if (contentItem) {
          resolve(contentItem);
        } else {
          getContentByMsgId(msg_id).then(res => {
            const content = res.data;
            commit("updateMessageContentStore", {
              msg_id,
              content
            });
            resolve(content);
          });
        }
      });
    },
    // 把一个未读消息标记为已读
    hasRead({
      state,
      commit
    }, {
      msg_id
    }) {
      return new Promise((resolve, reject) => {
        hasRead(msg_id).then(() => {
          commit("moveMsg", {
            from: "messageUnreadList",
            to: "messageReadedList",
            msg_id
          });
          commit("setMessageCount", state.unreadCount - 1);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 删除一个已读消息到回收站
    removeReaded({
      commit
    }, {
      msg_id
    }) {
      return new Promise((resolve, reject) => {
        removeReaded(msg_id).then(() => {
          commit("moveMsg", {
            from: "messageReadedList",
            to: "messageTrashList",
            msg_id
          });
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 还原一个已删除消息到已读消息
    restoreTrash({
      commit
    }, {
      msg_id
    }) {
      return new Promise((resolve, reject) => {
        restoreTrash(msg_id).then(() => {
          commit("moveMsg", {
            from: "messageTrashList",
            to: "messageReadedList",
            msg_id
          });
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取MFA配置
    reqMFAConfigs({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getUnitState().then(res => {
          const {
            retVal: {
              state
            },
            retVal
          } = res.data;
          let securityModel = state.toString()[0];
          let effectiveScope = state.toString()[1] ? state.toString()[1] : "";
          commit("setMFAConfigs", {
            securityModel,
            effectiveScope
          });
          commit("setPersonConfig", retVal);
          resolve(retVal);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取个人MFA配置
    reqPersonConfig({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getPersonalState().then(res => {
          const {
            retVal
          } = res.data;
          commit("setPersonConfig", retVal);
          resolve(retVal);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改MFA配置
    updateMFAConfigs({
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        saveMfaSettings(params).then(res => {
          resolve(res.data.result);
          dispatch("reqMFAConfigs");
          dispatch("reqPersonConfig");
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};